import CalendarMasterContainer from '../../../containers/common/calendarMaster/calendarMasterContainer';

export default function CalendarMaster(props) {
  const { onClose } = props;
  return (
    <CalendarMasterContainer onClose={onClose} />
  );
}
